import React from 'react';

import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import {PopoverBody} from 'reactstrap';

import {AttachOverlay, PopoverForm} from 'app/general/overlays';
import {ProcedureStepNumber} from 'app/procedures/components/ProcedureStepNumber';
import {StepSelect} from 'app/procedures/components/StepSelect';
import {getArtificialEndingStep} from 'app/procedures/utils';
import {gt} from 'app/utils/i18n';

import type {
  ApplyStepShaperFuncType,
  TargetStepIdType,
} from 'app/steps/document-shaper';
import type {AnyStepType} from 'sweet-types';

type Props = {
  stepId: string;
  next: string | undefined;
  steps: Array<AnyStepType>;
  applyStepShaper: ApplyStepShaperFuncType;
};

export function SetNextStepButton({
  stepId,
  steps,
  next,
  applyStepShaper,
}: Props) {
  const nextStep =
    find(steps, {
      id: next,
    }) ||
    steps[
      findIndex(steps, {
        id: stepId,
      }) + 1
    ] ||
    getArtificialEndingStep(null);

  const setNext = (next: TargetStepIdType, close: () => void) =>
    applyStepShaper(
      (stepShaper) =>
        stepShaper
          .setNext(next)
          .runSideEffect(() => (next != null ? close() : null))
          .procedure(),
      true
    );

  return (
    <AttachOverlay
      trigger="click legacy"
      overlay={({overlayProps}) => (
        <PopoverForm overlayProps={{...overlayProps, placement: 'bottom'}}>
          {({close}) => (
            <PopoverBody
              style={{
                width: 250,
              }}
            >
              <StepSelect
                skipStepId={stepId}
                value={find(steps, {
                  id: nextStep.id,
                })}
                onChange={(v) => setNext(v != null ? v : null, close)}
                steps={steps}
                onCreateStep={(title) =>
                  setNext(
                    {
                      type: 'newStep',
                      title: title || '',
                    },
                    close
                  )
                }
                menuIsOpen={next == null ? true : undefined}
              />
            </PopoverBody>
          )}
        </PopoverForm>
      )}
    >
      {(handlers) => (
        <button className="btn btn-sm btn-outline-primary" {...handlers}>
          <div className="d-flex align-items-center justify-content-center">
            {gt('Next step')}
            <ProcedureStepNumber
              className="ml-2 py-1"
              type={nextStep.type}
              n={nextStep.n == -1 ? null : nextStep.n}
            />
          </div>
        </button>
      )}
    </AttachOverlay>
  );
}
